import { OktaAuth } from '@okta/okta-auth-js';

export const authClient = new OktaAuth({
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID,
  decodeAccessTokens: true,
  issuer: import.meta.env.VITE_OKTA_ISSUER,
  redirectUri: typeof window !== 'undefined' ? `${window.location.origin}/login/callback` : '',
  scopes: ['openid', 'email', 'profile', 'offline_access'],
});
